<script>
export default {
  name: 'avaliacao-termo-aceite',
  props: {
    etapa: String
  },
  data () {
    return {
      aceite: false
    }
  },
  mounted () {
  },
  methods: {
    continuar () {
      this.$emit('update:etapa', 'tema')
    }
  }
}
</script>
<template>
  <div class="avaliacao-termo-aceite">
    <div class="page-content">
      <div class="page-header-content">
        <h2 class="page-title">Termo de aceite</h2>
      </div>
    </div>

    <div class="box pa-3">
      <div class="text-xs-center">
        Atenção candidato!<br>
        Leia o aceite abaixo para prosseguir com a realização da avaliação.

        <v-divider class="my-3"/>

        Estou ciente que durante a realização da prova não poderei fazer uso
        de materiais de consulta (livros, sites, etc.) e que não poderei compartilhar o link recebido
        com outras pessoas, sob risco de eliminação do processo seletivo.
      </div>

      <div class="mb-3">
        <v-checkbox v-model="aceite" color="primary" hide-details class="justify-center">
          <template v-slot:label>
            <div class="black--text">
              <strong>Li e concordo com os termos</strong>
            </div>
          </template>
        </v-checkbox>
      </div>

      <div>
        <v-btn color="primary"
               depressed
               large
               block
               :disabled="!aceite"
               @click="continuar()" class="my-0">
          Realizar avaliação
        </v-btn>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// TermoAceite.vue?69ddf2c8